import { Component, OnInit } from '@angular/core';
import { LazyLoadEvent, MessageService, SelectItem } from 'primeng';
import {
    FeedbackData,
    feedbackUpdateModel
} from 'src/app/models/feedback';
import {
    ErrorModel,
    PromiseResult,
    ServerError
} from 'src/app/models/PromiseResult';
import { FeedbackService } from 'src/app/services/feedback.service';
import { PaginationModel } from '../../../../models/util.models';
import { Title } from "@angular/platform-browser";
import { TraceClassDecorator } from '@sentry/angular';
import { DoctorBreadcrumbService } from "../../shared/breadcrumb.service";
import { ProviderStateService } from 'src/app/services/provider-state.service';


@TraceClassDecorator()
@Component({
    selector: 'app-covid-feedbacks',
    templateUrl: './covid-feedbacks.component.html',
    styleUrls: ['./covid-feedbacks.component.css'
        , '../../../../../assets/css/custom-egd.css'
    ]
})
export class CovidFeedbacksComponent implements OnInit {
    no_of_rows = [10, 25, 30, 50];
    feedbacksData: FeedbackData[] = [];
    loading: boolean;
    total_records: number = 0;

    currentFeedback: FeedbackData = null;
    response: PromiseResult;
    error: ErrorModel;
    serverError: ServerError;
    posting: boolean;
    fullFeedbackDialog: boolean = false;
    table_response: PromiseResult;
    table_error: ErrorModel;
    table_serverError: ServerError;
    table_posting: boolean;
    selected: boolean = false;
    updateData: feedbackUpdateModel;
    body = new PaginationModel();
    slug: string = "";

    constructor(
        private readonly breadcrumbService: DoctorBreadcrumbService,
        private readonly feedbackService: FeedbackService,
        private readonly messageService: MessageService,
        private readonly titleService: Title,
        private readonly providerstateService: ProviderStateService
    ) {
        this.body.page_no = 1;
        this.body.records_per_page = this.no_of_rows[0];
        
    }

    async ngOnInit(): Promise<void> {
        this.titleService.setTitle("Dashboard - Feedback");
        this.slug = this.providerstateService.getProviderSlug();
        this.breadcrumbService.setItems([
            { label: 'Dashboard', routerLink: [`/${this.slug}/doctor`] },
            { label: 'Feedback' }

        ]);
        this.updateData = {
            review_id: [],
            is_featured: null
        };
        this.ResetResultTableModels();
        this.ResetResultModels();
    }

    async getFeedbacks(event: LazyLoadEvent) {
        if (event) {
            this.body.page_no = event.first / event.rows + 1;
            this.body.records_per_page = event.rows;
        }
        this.loading = true;
        this.feedbacksData = []
        await this.feedbackService
            .getCovidFeedbacks(this.body)
            .toPromise()
            .then((result) => {
                this.table_response = result;
                const temp: FeedbackData[] = [];
                if (this.table_response.success) {
                    this.total_records = result.data.count;
                    result.data.rows.forEach((ele, index) => {
                        temp.push({
                            ...ele,
                            selected: false,
                            sr_no: index + 1 + (this.body.page_no - 1) * this.body.records_per_page,
                        });
                    })
                    this.feedbacksData = temp;
                }
            });
        this.loading = false;
    }

    private ResetResultTableModels(): void {
        this.table_response = {
            success: null,
            error: null,
            data: null
        };
        this.table_serverError = {
            statusCode: null,
            error: null,
            message: null
        };
    }

    private ResetResultModels(): void {
        this.response = {
            success: null,
            error: null,
            data: null
        };
        this.serverError = {
            statusCode: null,
            error: null,
            message: null
        };
    }

    async addToFeatured(featured_value: boolean): Promise<void> {
        for (const f of this.feedbacksData)
            if (f.selected) this.updateData.review_id.push(f.id);
        if (this.updateData.review_id.length == 0) {
            this.messageService.add({
                severity: 'error',
                summary: 'Error',
                detail: 'Please select at least one feedback'
            });
            return;
        }
        this.updateData.is_featured = featured_value;
        this.ResetResultModels();
        this.loading = true;
        await this.feedbackService
            .updateCovidFeedback(this.updateData)
            .toPromise()
            .then((result) => {
                this.response = result;
                if (result.success) {
                    this.updateData = {
                        review_id: [],
                        is_featured: null
                    };
                    for (const f of this.feedbacksData) {
                        if (f.selected) {
                            f.selected = false;
                            f.is_featured = featured_value;
                        }
                    }
                    this.messageService.add({
                        severity: 'success',
                        summary: 'Success',
                        detail: 'Feedbacks have been updated successfully'
                    });
                }
                this.loading = false;
            });
    }
    async ViewFull(id: number): Promise<void> {
        this.currentFeedback = null;
        for (const f of this.feedbacksData)
            if (f.id == id) {
                this.currentFeedback = f;
                break;
            }
        if (this.currentFeedback) {
            this.fullFeedbackDialog = true;
            this.currentFeedback.source = this.currentFeedback.source.split('_').join(' ');
        }

    }
}
